<div class="video-overlay-container" #videoParent></div>
